// Toggle header background when drawer opens on dark pages
document.addEventListener('DOMContentLoaded', function() {
  const detailsMenu = document.getElementById('Details-menu-drawer-container');

  if (!detailsMenu) return;

  const isDarkPage = document.body.classList.contains('page-press') ||
                     document.body.classList.contains('page-coming-soon2');

  if (!isDarkPage) return;

  // Get the header element
  const header = detailsMenu.closest('.header');
  if (!header) return;

  // Listen for open/close
  detailsMenu.addEventListener('toggle', function() {
    if (this.open) {
      header.classList.add('header--drawer-open-dark-page');
    } else {
      header.classList.remove('header--drawer-open-dark-page');
    }
  });
});
